module.exports = __webpack_public_path__ + "img/icon_map_1_yj_hg_c.f53c716e.png";